import React, { useState} from 'react'
import { Text, Checkbox, Heading } from 'base-ui'
import { PageWrapper } from './PageWrapper'
import { Checkbox as CheckboxExample } from '../examples/Checkbox'
import { CheckboxList as CheckboxListExample } from '../examples/Checkbox'
import Highlighter from './Highlight'

const checkboxes = [
    {
        id: "custom-checkbox",
        label: "Label for Checkbox",
        name: "checkbox",
        description: "Description for checkbox",
        value: "check-box-value",
        checked: false,
        disabled: false
    },
    {
        id: "custom-checkbox",
        label: "Label for Checkbox",
        name: "checkbox",
        description: "Description for checkbox",
        value: "check-box-value",
        checked: false,
        disabled: false
    },
    {
        id: "custom-checkbox",
        label: "Label for Checkbox",
        name: "checkbox",
        description: "Description for checkbox",
        value: "check-box-value",
        checked: false,
        disabled: false
    }
]

const Checkboxes = () => {

    const [checkedState, setCheckedState] = useState( new Array(checkboxes.length).fill(false) );    
    const handleOnChange = (position: any) => {
        const updatedCheckedState = checkedState.map((item, index) =>
            index === position ? !item : item
        );
        setCheckedState(updatedCheckedState);
    };


    // Single checkbox state
    const [checked1, setChecked1] = useState(false)
    const [checked2, setChecked2] = useState(false)
    const [checked3, setChecked3] = useState(false)
    const [checked5, setChecked5] = useState(false)
    const [checked6, setChecked6] = useState(true)
    const [checked7, setChecked7] = useState(false)

    const [invalid, setInvalid] = useState(true)

    
    const handleCheckedAndInvalid =  () => {
        setChecked7(!checked7)
        setInvalid(!invalid)
    }
    
  return (
    <PageWrapper title="Checkbox">
        <Text size="lg">The Checkbox component is used in forms when a user needs to select multiple values from several options.</Text>

        <Heading size="h3">Single Checkbox</Heading>
        <div className='space-y-4'>

            <div>
                <Heading size='h6'>
                    Empty
                </Heading>
                <div className='py-2 grid grid-cols-4'>
                    <Checkbox
                        id='single-checkbox-1'
                        value='single-checkbox-1'
                        isDisabled={false}
                        isChecked={checked1}
                        className='custom-class'
                        onChange={ () => setChecked1(!checked1) }
                    />
                    <Checkbox
                        id='single-checkbox-6'
                        value='single-checkbox-1'
                        isDisabled={false}
                        isChecked={checked6}
                        className='custom-class'
                        onChange={ () => setChecked6(!checked6) }
                    />
                    <Checkbox
                        id='single-checkbox-5'
                        value='single-checkbox-1'
                        isDisabled={true}
                        isChecked={checked5}
                        className='custom-class'
                        onChange={ () => setChecked5(checked5) }
                    />
                    <Checkbox
                        id='single-checkbox-4'
                        value='single-checkbox-1'
                        isDisabled={false}
                        isChecked={checked7}
                        className='custom-class'
                        isInvalid={invalid}
                        onChange={ handleCheckedAndInvalid }
                    />
                </div>
            </div>

            <div>
                <Heading size='h6'>
                    With Label
                </Heading>
                <div className='py-2'>
                    <Checkbox
                        id='single-checkbox-2'
                        label='Single checkbox'
                        name='single-checkbox-1'
                        value='single-checkbox-1'
                        isDisabled={false}
                        isChecked={checked2}
                        className='custom-class'
                        onChange={ () => setChecked2(!checked2) }
                    />
                </div>
            </div>

            <Heading size='h6'>
                With description
            </Heading>
            <div className='py-2'>
                <Checkbox
                    id='single-checkbox-3'
                    label='Single checkbox'
                    name='single-checkbox-1'
                    description='Description for checkbox'
                    value='single-checkbox-1'
                    isDisabled={false}
                    isChecked={checked3}
                    className='custom-class'
                    onChange={ () => setChecked3(!checked3) }
                />
            </div>

            <Heading size='h6'>
                With Error
            </Heading>
            <div className='py-2'>
                <Checkbox
                    id='single-checkbox-7'
                    label='Single checkbox'
                    name='single-checkbox-1'
                    description='Description for checkbox'
                    value='single-checkbox-1'
                    isDisabled={false}
                    isChecked={checked7}
                    isInvalid={invalid}
                    invalidLabel='You need to check this box to continue'
                    className='custom-class'
                    onChange={handleCheckedAndInvalid}
                />
            </div>
        </div>
        <Heading size="h3">Usage</Heading>
        <Highlighter code={CheckboxExample} language='jsx' />

        <Heading size="h3" className='mt-8'>Checkbox List</Heading>
        <div className='space-y-4'>
            {checkboxes.map(({ id, label, name, description, value, disabled }, index) => {
            return (
                <Checkbox
                    id={`${id}-${index}`}
                    label={label? `${label}` : ""}
                    name={name? `${name}` : ""}
                    description={description? `${description}` : ""}
                    value={value? `${value}-${index}` : ""}
                    isDisabled={disabled}
                    isChecked={checkedState[index]}
                    className='custom-class'
                    onChange={ () => { handleOnChange(index) } }
                />
            );
            })}
        </div>
        <Heading size="h3">Example</Heading>
        <Highlighter code={CheckboxListExample} language='jsx' />
        
    </PageWrapper>
  )
}

export default Checkboxes